import * as types from "@/redux/types";

export const openAlertHandler = (
    message,
    status,
    duration,
) => ({
    payload: {
        duration,
        message,
        status,
    },
    type: types.OPEN_ALERT,
});

export const closeAlertHandler = () => ({ type: types.CLOSE_ALERT });
